import React, { lazy, Suspense } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode"; // Correct import for v4+
const FloatingMessagingWidget = lazy(() => import("../CleanSlateApp/Users/Master/Modals/MessageModal/FloatingMessagingWidget"));

const ProtectedRoute = ({ children }) => {
	const token = Cookies.get("token");
	const { pathname } = useLocation();
	const normalizedPath = String(pathname || "").toLowerCase();

	const hideFloatingWidget =
		normalizedPath.endsWith("personaldiary") ||
		normalizedPath.includes("/inbox");

	if (!token) {
		return <Navigate to="/Auth" replace />;
	}

	try {
		const decoded = jwtDecode(token);
		const currentTime = Date.now() / 1000; // Convert to seconds

		// If current time is greater than the exp timestamp, it's expired
		if (decoded.exp < currentTime) {

			// Optional: Clean up the expired cookie immediately
			Cookies.remove("token");

			return <Navigate to="/Auth" replace />;
		}
	} catch (error) {
		// If the token is malformed or can't be decoded
		Cookies.remove("token");
		return <Navigate to="/Auth" replace />;
	}

	return (
		<>
			{children}
			<Suspense fallback={null}>
				{!hideFloatingWidget && <FloatingMessagingWidget />}
			</Suspense>
		</>
	);
};

export default ProtectedRoute;
